import React from 'react'
import { PrismicRichText } from '@prismicio/react'

const Accordion = ({ slice }) => {
  return (
    <section className={`component-${slice.slice_type} space-y-6 px-4 py-5 sm:py-10`}>
      {slice.primary.title && <h2 className='text-center max-w-3xl mx-auto'>{slice.primary.title.text}</h2>}
      {slice.primary.richText && (
        <div className='prose prose-lg dark:prose-invert text-center max-w-3xl mx-auto'>
          <PrismicRichText field={slice.primary.text.richText} />
        </div>
      )}
      <ul className='mt-6 max-w-4xl mx-auto divide-y divide-gray-200 dark:divide-gray-700'>
        {slice.items.map((accordion, index) => {
          return (
            <li key={`accordion-${index}`}>
              <details className='p-6 text-lg text-left w-full flex justify-between items-start' itemScope itemProp='mainEntity' itemType='https://schema.org/Question'>
                <summary className='text-xl text-gray-800 dark:text-gray-100 hover:text-indigo-500 dark:hover:text-purple-300 m-0 flex justify-between cursor-pointer w-full text-left focus:outline-none focus:ring focus:ring-indigo-100 rounde'>
                  <div className='flex-1' itemProp='name'>
                    <PrismicRichText field={accordion.question.richText} />
                  </div>
                  <svg xmlns='http://www.w3.org/2000/svg' fill='currentColor' viewBox='0 0 24 24' className='w-8'>
                    <title>Indicator Arrow</title>
                    <path d='M0 0h24v24H0V0z' fill='none' />
                    <path d='M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z' />
                  </svg>
                </summary>
                <div className='mt-3 mr-6' itemScope itemProp='acceptedAnswer' itemType='https://schema.org/Answer'>
                  <div className='prose prose-lg dark:prose-invert min-w-full' itemProp='text'>
                    <PrismicRichText field={accordion.answer.richText} />
                  </div>
                </div>
              </details>
            </li>
          )
        })}
      </ul>
    </section>
  )
}

export default Accordion
